/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BranchDto } from '../models/branch-dto';

@Injectable({
  providedIn: 'root',
})
export class BranchRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getBranchById
   */
  static readonly GetBranchByIdPath = '/api/v1/branches/{id}';

  /**
   * Provides BranchDto based on the given Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBranchById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBranchById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<BranchDto>> {

    const rb = new RequestBuilder(this.rootUrl, BranchRestControllerService.GetBranchByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BranchDto>;
      })
    );
  }

  /**
   * Provides BranchDto based on the given Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBranchById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBranchById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<BranchDto> {

    return this.getBranchById$Response(params,context).pipe(
      map((r: StrictHttpResponse<BranchDto>) => r.body as BranchDto)
    );
  }

  /**
   * Path part for operation getBranches
   */
  static readonly GetBranchesPath = '/api/v1/branches/all';

  /**
   * Provides the list of all Branches.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBranches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBranches$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<BranchDto>>> {

    const rb = new RequestBuilder(this.rootUrl, BranchRestControllerService.GetBranchesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BranchDto>>;
      })
    );
  }

  /**
   * Provides the list of all Branches.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBranches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBranches(params?: {
  },
  context?: HttpContext

): Observable<Array<BranchDto>> {

    return this.getBranches$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<BranchDto>>) => r.body as Array<BranchDto>)
    );
  }

}
